import { financeModule } from './finance';
import { healthModule } from './health';
import { nutritionModule } from './nutrition';
import { trainingModule } from './training';
import type { ModuleDefinition } from './types';

/** Every business module the app knows. Order = navigation order. */
export const MODULES: readonly ModuleDefinition[] = [
  trainingModule,
  nutritionModule,
  healthModule,
  financeModule,
];
